<template>
  <v-container fluid class="bgc-body pa-0">

        <v-row>

          <header class="w100%">
            <v-row no-gutters class="bgc-jumbo">
              <v-col cols="10" offset="1" offset-sm="1" md="8" offset-md="2" lg="6" offset-lg="3" align="center">
                <div class="h100% lh1.3 tac">
                  <prismic-rich-text class="fOswald fz28 fw400 lts4 c-white mih200 tac pt50 ttu pb50" :field="post.data.title" :htmlSerializer="htmlSerializer" />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" offset="1" md="8" offset-md="2" lg="6" offset-lg="3" class="posr">
                <div class="df aic jcc">
                  <v-img src="@/assets/images/gooch-headshot1.jpg" class="maw100i bd4-s-wrap bdrs100% wauto m-50%" alt="Gooch" itemprop="image"/>
                  <!-- <v-img src="@/assets/images/gooch-headshot1.jpg" class="maw100 bd4-s-wrap bdrs100% wauto h12vh@md m-50%" alt="Gooch" itemprop="image"/> -->
                </div>
                <div class="df aic jcc mt2em">
                  <!-- TODO: redo these stupid line to make them enimate in the correct spot -->
                  <div class="w0 h1 bgc-orange mt4em posa l25 line-w-post line-transition-left"></div>
                      <h3 class="fOswald fw400 mt3.5em">{{post.data.date | fixDate}}</h3>
                  <div class="w0 h1 bgc-orange mt4em posa r25 line-w-post line-transition-right"></div>
                </div>
              </v-col>
            </v-row>
              <v-col cols="10" offset="1" md="8" offset-md="2" lg="6" offset-lg="3" class="tal mt20 mb20">
                <h5 class="fOswald fw400 fz100%">
                    Posted in 
                    <span class="fw700"
                      v-for="cat in post.data.categories"
                      :key="cat.id"
                    >
                      <router-link :to="'/blog/'+cat.slug">{{cat.slug | capitalize}}</router-link><span v-if="cat.id < post.data.categories.length-1">, </span>
                    </span> by Gooch
                </h5>
            </v-col>
          </header>
        </v-row>
      <!-- </div> -->
          <article>
      <v-row>
          <v-col cols="10" offset="1" md="8" offset-md="2" lg="6" offset-lg="3" class="tal">
            <div class="post">
              <v-img :v-if="post.data.media" :src="post.data.media.url" lazy-src="@/assets/images/700x400.png" class="w100% img-responsive bxsh1-2-2-1-bbb"/>
              <div
                v-for="(slice, index) in post.data.body"
                :key="'slice-' + index"
              >
                <p v-if="slice.slice_type == 'image_with_caption'">
                  <v-img :src="slice.primary.imagelink.url" lazy-src="@/assets/images/700x400.png" class="hauto maw100% db mt10 bxsh1-2-2-1-bbb" :alt="slice.primary.imagelink.url" :title="slice.primary.imagelink.url"/>
                </p>
                <prismic-rich-text v-if="slice.slice_type == 'text'" :field="slice.primary.text" :htmlSerializer="htmlSerializer" />
                
                <pre v-if="slice.slice_type == 'codeblock'" :class="slice.primary.code[0].label + ' fz.92emi'"><code :class="'fw400 noshadow '+slice.primary.code[0].label" v-html="$options.filters.highlight(slice.primary.code[0].text)" /></pre>
          
                <div v-if="slice.slice_type == 'notice'" :class="slice.primary.type">
                  <prismic-rich-text :field="slice.primary.copy" :htmlSerializer="htmlSerializer" />
                </div>
              </div>


            </div>
          </v-col>
      </v-row>
    </article>
  </v-container>
</template>

<style scoped>
.bgc-body {
  background-color: #f4f4f4;
}
.noshadow {
  box-shadow: none;
  -webkit-box-shadow: none;
}
.fz100\% {
  font-size: 100%;
}
.v-application code::before {
  content: '';
}
.mt2em {
  margin-top: 2em;
}
.maw100i {
  max-width: 100px !important;
}
.line-transition-left {
  transition: width 1s ease;
  transform-origin: left 50% 0px;
  visibility: inherit;
  opacity: 1;
  transform: matrix(.9, 0, 0, 1, 0, 0);
}
.line-transition-right {
  transition: width 1s ease;
  transform-origin: right 50% 0px;
  visibility: inherit;
  opacity: 1;
  transform: matrix(.9, 0, 0, 1, 0, 0);
}
.fz\.92emi {
  font-size: .92em !important;
}
</style>

<script>
import htmlSerializer from '../helpers/html-serializer';
import moment from 'moment';

export default {
  components: {

  },
  props: {
    uid: {type: String}
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    fixDate: function (value) {
      let date;
      let f = 'MMMM Do, YYYY';
      date = moment(value).format(f);
      return date
    }
  },
  created: function() {
    this.getPostData();
  },

  methods: {
    getPostData () {
      this.$prismic.client.query( // start the all query
        this.$prismic.Predicates.at('my.post.uid', this.uid),
          { fetchLinks: 'categories.category.slug' }
      ).then((response) => {
          let cats = response.results[0].data.categories
          response.results[0].data.categories = []
          let i=0;
          cats.forEach(linkedCategories => {
            response.results[0].data.categories.push({id: i, slug: linkedCategories.category.slug});
            i++
          });
          this.post = response.results[0]
      }) // end the all query
    },
  },
  data() {
    return {
      htmlSerializer,
      post: '',
      cleanCategories: []
    }
  },
}
</script>